var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHot1Shadow = function SvgHot1Shadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 472.5,
    height: 87,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hot-1-shadow_svg__b",
    x1: 0.5,
    x2: 0.121,
    y1: 0.788,
    y2: 0.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "2.143%",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hot-1-shadow_svg__a",
    width: 1.124,
    height: 2.486,
    x: -0.062,
    y: -0.743,
    colorInterpolationFilters: "sRGB",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 6.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hot-1-shadow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hot-1-shadow_svg__b)",
    d: "M26 61h420.5L176 26z"
  }))));
};
export default SvgHot1Shadow;